import React, { useState, useCallback, useEffect, useContext } from "react";
import { BiArrowBack, BiLoader } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import Custombutton from "../../Common/Custombutton";
import { notificationHandler } from "../../utils/Notification";
import {
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
} from "@mui/material";
import { MdDelete, MdOutlineAddCard } from "react-icons/md";
import s from "./newPuja.module.css";
import { getBaseUrl, getBaseUrl2 } from "../../utils";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AddNewPuja = () => {
  const navigate = useNavigate();
  const locationData = useLocation();
  const pagetype = locationData.state?.pagetype || "Add";
  const [isLoading,setisLoading]=useState(false)
  // State initialization
  const [name, setName] = useState("");
  const [titleHindi, setTitleHindi] = useState("");
  const [location, setLocation] = useState("");
  const [hindiLocation, setHindiLocation] = useState("");
  const [priority, setPriority] = useState("");
  const [date, setDate] = useState("");
  const [desc, setDesc] = useState("");
  const [hindiDesc, setHindiDesc] = useState("");
  const [primaryGodName, setPrimaryGodName] = useState("");
  const [purpose, setPurpose] = useState("");
  const [price, setPrice] = useState("");
  const [priceInDollar, setPriceInDollar] = useState("");
  const [shortdesc, setShortdesc] = useState("");
  const [shorthindiDesc, setShorthindiDesc] = useState("");
  const [madirDetails, setMadirDetails] = useState("");
  const [madirhindiDetails, setMadirhindiDetails] = useState("");
  const [benefits, setBenefits] = useState([{ header: "", hindiHeader: "", description: "", hindiDescription: "" }]);
  const [offerings, setOfferings] = useState([{ title: "", hindiTitle: "", price: "", dollarPrice: "" }]);
  const [numberOfMembers, setNumberOfMembers] = useState([{ title: "", hindiTitle: "", price: "", dollarPrice: "" }]);
  const [prasadHomeDelivery, setPrasadHomeDelivery] = useState([{ title: "", hindiTitle: "", price: "", dollarPrice: "" }]);
  const [pujaProcess, setPujaProcess] = useState([{ stepNumber: 1, title: "", hindiTitle: "", description: "", hindiDescription: "" }]);
  const [liveDarshanLinks, setLiveDarshanLinks] = useState([""]);
  const [thumbnail, setThumbnail] = useState([]);
  const [madirImage, setMadirImage] = useState(null);
  const [benefitsIcons, setBenefitsIcons] = useState([]);
  const [thumbnailUrls, setThumbnailUrls] = useState([]);
  const [madirImageUrl, setMadirImageUrl] = useState("");
  const [benefitsIconsUrls, setBenefitsIconsUrls] = useState([]);
  const [cardImage,setCardImage]= useState(null)
  const [cardImageUrl,setCardImageUrl]= useState(null)
  console.log(thumbnail,"this is fro the thumbnails in the asssas sas sasa asas asas asas asas")
  useEffect(() => {
    if (pagetype === "Edit" && locationData?.state?.data) {
      const data = locationData.state.data;
      console.log(data,"this is for hte data which come from the previoius page")
      setName(data.name || "");
      setTitleHindi(data.titleHindi || "");
      setLocation(data.location || "");
      setHindiLocation(data.hindiLocation || "");
      setPriority(data.priority || "");
      // Format date for datetime-local input
      setDate(data.date ? new Date(data.date).toISOString().slice(0, 16) : "");
      setDesc(data.desc || "");
      setHindiDesc(data.hindiDesc || "");
      setPrimaryGodName(data.primaryGodName || "");
      setPurpose(data.purpose || "");
      setPrice(data.price || "");
      setPriceInDollar(data.priceInDollar || "");
      setShortdesc(data.shortdesc || "");
      setShorthindiDesc(data.shorthindiDesc || "");
      setMadirDetails(data.madirDetails || "");
      setMadirhindiDetails(data.madirhindiDetails || "");
      setBenefits(data.benefits || [{ header: "", hindiHeader: "", description: "", hindiDescription: "" }]);
      setOfferings(data.offerings.length> 0 && data?.offerings || [{ title: "", hindiTitle: "", price: "", dollarPrice: "" }]);
      setNumberOfMembers(data.numberOfMembers || [{ title: "", hindiTitle: "", price: "", dollarPrice: "" }]);
      setPrasadHomeDelivery(data.prasadHomeDelivery || [{ title: "", hindiTitle: "", price: "", dollarPrice: "" }]);
      setPujaProcess(data.pujaProcess || [{ stepNumber: 1, title: "", hindiTitle: "", description: "", hindiDescription: "" }]);
      setLiveDarshanLinks(data.liveDarshanLinks || [""]);
      setThumbnail([]);
      setThumbnailUrls(data.thumbnail?.map((img) => getBaseUrl2() + img.url) || []);
      setMadirImage(getBaseUrl2() +   data.madirImage || null);
      setMadirImageUrl(getBaseUrl2() + data.madirImage || "");
      setCardImage(data.mainImage || "");
      setCardImageUrl(data.mainImage || "");
      setBenefitsIcons(data.benefitsIcons || []);
      setBenefitsIconsUrls(data.benefitsIcons?.map((img) => img.url) || []);
    }
  }, [locationData, pagetype]);
  // Handle array field changes
  const handleArrayChange = (index, field, value, setFunction) => {
    const updatedData = [...field];
    updatedData[index] = value;
    setFunction(updatedData);
  };
  // Add new row to array fields
  const addNewRow = (setFunction, initialValue) => {
    setFunction((prev) => [...prev, initialValue]);
  };
  // Delete row from array fields
  const deleteRow = (index, setFunction) => {
    if (index === 0) return;
    setFunction((prev) => prev.filter((_, i) => i !== index));
  };
  const handleImageChange = (e, setFunction, setUrlFunction) => {
    const files = Array.from(e.target.files);
    setFunction(files);
    setUrlFunction(files.map((file) => URL.createObjectURL(file)));
  };
  const handleSingleImageChange = (e, setFunction, setUrlFunction) => {
    const file = e.target.files[0];
    setFunction(file);
    setUrlFunction(file ? URL.createObjectURL(file) : "");
  };
  const addPujaFunc = async () => {
    setisLoading(true)
    const fd = new FormData();
    fd.append("name", name);
    fd.append("titleHindi", titleHindi);
    fd.append("location", location);
    fd.append("hindiLocation", hindiLocation);
    fd.append("priority", priority);
    fd.append("date", date);
    fd.append("desc", desc);
    fd.append("hindiDesc", hindiDesc);
    fd.append("primaryGodName", primaryGodName);
    fd.append("purpose", purpose);
    fd.append("price", price);
    fd.append("priceInDollar", priceInDollar);
    fd.append("shortdesc", shortdesc);
    fd.append("shorthindiDesc", shorthindiDesc);
    fd.append("madirDetails", madirDetails);
    fd.append("madirhindiDetails", madirhindiDetails);
    fd.append("benefits", JSON.stringify(benefits));
    if(offerings[0].title !== ""){
      fd.append("offerings", JSON.stringify(offerings));
    }
    fd.append("numberOfMembers", JSON.stringify(numberOfMembers));
    if(prasadHomeDelivery !==""){
      fd.append("prasadHomeDelivery", JSON.stringify(prasadHomeDelivery));
    }
    fd.append("pujaProcess", JSON.stringify(pujaProcess));
    fd.append("liveDarshanLinks", JSON.stringify(liveDarshanLinks));
    thumbnail.forEach((file) => fd.append("thumbnail", file));
    if (madirImage) fd.append("madirImage", madirImage);
    if (cardImage) fd.append("mainImage", cardImage);
    // benefitsIcons.forEach((file) => fd.append("benefitsIcons", file));
    try {
      const res = await fetch(getBaseUrl() + "admin/addPuja", {
        method: "POST",
        body: fd,
      });
      const result = await res.json();
      if (result.status) {
        navigate("/new-puja-list");
        notificationHandler({ type: "success", msg: result.message });
        setisLoading(false)
      } else {
        notificationHandler({ type: "danger", msg: result.message });
        setisLoading(false)
      }
    } catch (error) {
      notificationHandler({ type: "danger", msg: error.message });
      setisLoading(false)
    }
  };
const updatePujaFunc = async () => {
   setisLoading(true)
    const fd = new FormData();
    fd.append("name", name);
    fd.append("titleHindi", titleHindi);
    fd.append("location", location);
    fd.append("hindiLocation", hindiLocation);
    fd.append("priority", priority);
    fd.append("date", date);
    fd.append("desc", desc);
    fd.append("hindiDesc", hindiDesc);
    fd.append("primaryGodName", primaryGodName);
    fd.append("purpose", purpose);
    fd.append("price", price);
    fd.append("priceInDollar", priceInDollar);
    fd.append("shortdesc", shortdesc);
    fd.append("shorthindiDesc", shorthindiDesc);
    fd.append("madirDetails", madirDetails);
    fd.append("madirhindiDetails", madirhindiDetails);
    fd.append("benefits", JSON.stringify(benefits));
    // fd.append("offerings", JSON.stringify(offerings));
     if(offerings[0].title !== ""){
      fd.append("offerings", JSON.stringify(offerings));
    }
    fd.append("numberOfMembers", JSON.stringify(numberOfMembers));
    // fd.append("prasadHomeDelivery", JSON.stringify(prasadHomeDelivery));
     if(prasadHomeDelivery !==""){
      fd.append("prasadHomeDelivery", JSON.stringify(prasadHomeDelivery));
    }
    fd.append("pujaProcess", JSON.stringify(pujaProcess));
    fd.append("liveDarshanLinks", JSON.stringify(liveDarshanLinks));
    thumbnail.forEach((file) => fd.append("thumbnail", file));
    if (madirImage) fd.append("madirImage", madirImage);
 if (cardImage) fd.append("mainImage", cardImage);
    try {
      const res = await fetch(
        getBaseUrl() + `admin/updatePuja/${locationData.state.data._id}`,
        {
          method: "PATCH",
          body: fd,
        }
      );
      const result = await res.json();
      if (result.status) {
        navigate("/new-puja-list");
        notificationHandler({ type: "success", msg: result.message });
         setisLoading(false)
      } else {
        notificationHandler({ type: "danger", msg: result.message });
         setisLoading(false)
      }
    } catch (error) {
      notificationHandler({ type: "danger", msg: error.message });
       setisLoading(false)
    }
  };
  const handleSubmit = () => {
    if(isLoading){
      console.log("already loading")
      return;
    }
    if (pagetype === "Edit") {
      updatePujaFunc();
    } else {
      addPujaFunc();
    }
  };
  return (
    <div>
      <Card className={s["add-new-puja-card"]} style={{ padding: "20px" }}>
        <div className={s["title"]} onClick={() => navigate(-1)}>
          <BiArrowBack /> Back
        </div>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Title Hindi</label>
              <input
                type="text"
                className="form-control"
                value={titleHindi}
                onChange={(e) => setTitleHindi(e.target.value)}
                placeholder="Title in Hindi"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Location</label>
              <input
                type="text"
                className="form-control"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                placeholder="Location"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Hindi Location</label>
              <input
                type="text"
                className="form-control"
                value={hindiLocation}
                onChange={(e) => setHindiLocation(e.target.value)}
                placeholder="Location in Hindi"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Priority</label>
              <input
                type="text"
                className="form-control"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                placeholder="Priority"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Date</label>
              <input
                type="datetime-local"
                className="form-control"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                placeholder="Date"
              />
            </div>
          </Grid>
          <Grid item xs={12} style={{ height: "17rem" }}>
            <div className="form-group">
              <label>Description</label>
              <ReactQuill
                value={desc}
                onChange={setDesc}
                style={{ height: "11rem" }}
                placeholder="Description"
                rows={5}
              />
            </div>
          </Grid>
          <Grid item xs={12} style={{ height: "17rem" }}>
            <div className="form-group">
              <label>Hindi Description</label>
              <ReactQuill
                value={hindiDesc}
                style={{ height: "11rem" }}
                onChange={setHindiDesc}
                placeholder="Description in Hindi"
                rows={5}
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Primary God Name</label>
              <input
                type="text"
                className="form-control"
                value={primaryGodName}
                onChange={(e) => setPrimaryGodName(e.target.value)}
                placeholder="Primary God Name"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Purpose</label>
              <input
                type="text"
                className="form-control"
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
                placeholder="Purpose"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Price</label>
              <input
                type="text"
                className="form-control"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Price"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Price in Dollar</label>
              <input
                type="text"
                className="form-control"
                value={priceInDollar}
                onChange={(e) => setPriceInDollar(e.target.value)}
                placeholder="Price in Dollar"
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Short Description</label>
              <textarea
                className="form-control"
                value={shortdesc}
                onChange={(e) => setShortdesc(e.target.value)}
                placeholder="Short Description"
                rows={3}
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Short Hindi Description</label>
              <textarea
                className="form-control"
                value={shorthindiDesc}
                onChange={(e) => setShorthindiDesc(e.target.value)}
                placeholder="Short Description in Hindi"
                rows={3}
              />
            </div>
          </Grid>
          <Grid item xs={12} style={{ height: "17rem" }}>
            <div className="form-group">
              <label>Madir Details</label>
              <ReactQuill
                value={madirDetails}
                onChange={setMadirDetails}
                style={{ height: "11rem" }}
                placeholder="Madir Details"
                rows={5}
              />
            </div>
          </Grid>
          <Grid item xs={12} style={{ height: "17rem" }}>
            <div className="form-group">
              <label>Madir Hindi Details</label>
              <ReactQuill
                value={madirhindiDetails}
                style={{ height: "11rem" }}
                onChange={setMadirhindiDetails}
                placeholder="Madir Details in Hindi"
                rows={5}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group">
              <label>Benefits</label>
              <Table>
                <TableHead>
                  <TableCell align="center">Header</TableCell>
                  <TableCell align="center">Hindi Header</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Hindi Description</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableHead>
                {benefits.map((item, index) => (
                  <TableBody key={index}>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.header}
                        onChange={(e) => {
                          const updated = [...benefits];
                          updated[index].header = e.target.value;
                          setBenefits(updated);
                        }}
                        placeholder="Header"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.hindiHeader}
                        onChange={(e) => {
                          const updated = [...benefits];
                          updated[index].hindiHeader = e.target.value;
                          setBenefits(updated);
                        }}
                        placeholder="Hindi Header"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <textarea
                        className="form-control"
                        value={item.description}
                        onChange={(e) => {
                          const updated = [...benefits];
                          updated[index].description = e.target.value;
                          setBenefits(updated);
                        }}
                        placeholder="Description"
                        rows={3}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <textarea
                        className="form-control"
                        value={item.hindiDescription}
                        onChange={(e) => {
                          const updated = [...benefits];
                          updated[index].hindiDescription = e.target.value;
                          setBenefits(updated);
                        }}
                        placeholder="Hindi Description"
                        rows={3}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <button
                        onClick={() =>
                          addNewRow(setBenefits, { header: "", hindiHeader: "", description: "", hindiDescription: "" })
                        }
                      >
                        <MdOutlineAddCard size={20} />
                      </button>
                      <button onClick={() => deleteRow(index, setBenefits)}>
                        <MdDelete size={20} />
                      </button>
                    </TableCell>
                  </TableBody>
                ))}
              </Table>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group">
              <label>Offerings</label>
              <Table>
                <TableHead>
                  <TableCell align="center">Title</TableCell>
                  <TableCell align="center">Hindi Title</TableCell>
                  <TableCell align="center">Price</TableCell>
                  <TableCell align="center">Dollar Price</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableHead>
                {offerings.map((item, index) => (
                  <TableBody key={index}>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.title}
                        onChange={(e) => {
                          const updated = [...offerings];
                          updated[index].title = e.target.value;
                          setOfferings(updated);
                        }}
                        placeholder="Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.hindiTitle}
                        onChange={(e) => {
                          const updated = [...offerings];
                          updated[index].hindiTitle = e.target.value;
                          setOfferings(updated);
                        }}
                        placeholder="Hindi Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.price}
                        onChange={(e) => {
                          const updated = [...offerings];
                          updated[index].price = e.target.value;
                          setOfferings(updated);
                        }}
                        placeholder="Price"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.dollarPrice}
                        onChange={(e) => {
                          const updated = [...offerings];
                          updated[index].dollarPrice = e.target.value;
                          setOfferings(updated);
                        }}
                        placeholder="Dollar Price"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <button
                        onClick={() =>
                          addNewRow(setOfferings, { title: "", hindiTitle: "", price: "", dollarPrice: "" })
                        }
                      >
                        <MdOutlineAddCard size={20} />
                      </button>
                      <button onClick={() => deleteRow(index, setOfferings)}>
                        <MdDelete size={20} />
                      </button>
                    </TableCell>
                  </TableBody>
                ))}
              </Table>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group">
              <label>Number of Members</label>
              <Table>
                <TableHead>
                  <TableCell align="center">Title</TableCell>
                  <TableCell align="center">Hindi Title</TableCell>
                  <TableCell align="center">Price</TableCell>
                  <TableCell align="center">Dollar Price</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableHead>
                {numberOfMembers.map((item, index) => (
                  <TableBody key={index}>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.title}
                        onChange={(e) => {
                          const updated = [...numberOfMembers];
                          updated[index].title = e.target.value;
                          setNumberOfMembers(updated);
                        }}
                        placeholder="Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.hindiTitle}
                        onChange={(e) => {
                          const updated = [...numberOfMembers];
                          updated[index].hindiTitle = e.target.value;
                          setNumberOfMembers(updated);
                        }}
                        placeholder="Hindi Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.price}
                        onChange={(e) => {
                          const updated = [...numberOfMembers];
                          updated[index].price = e.target.value;
                          setNumberOfMembers(updated);
                        }}
                        placeholder="Price"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.dollarPrice}
                        onChange={(e) => {
                          const updated = [...numberOfMembers];
                          updated[index].dollarPrice = e.target.value;
                          setNumberOfMembers(updated);
                        }}
                        placeholder="Dollar Price"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <button
                        onClick={() =>
                          addNewRow(setNumberOfMembers, { title: "", hindiTitle: "", price: "", dollarPrice: "" })
                        }
                      >
                        <MdOutlineAddCard size={20} />
                      </button>
                      <button
                        onClick={() => deleteRow(index, setNumberOfMembers)}
                      >
                        <MdDelete size={20} />
                      </button>
                    </TableCell>
                  </TableBody>
                ))}
              </Table>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group">
              <label>Prasad Home Delivery</label>
              <Table>
                <TableHead>
                  <TableCell align="center">Title</TableCell>
                  <TableCell align="center">Hindi Title</TableCell>
                  <TableCell align="center">Price</TableCell>
                  <TableCell align="center">Dollar Price</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableHead>
                {prasadHomeDelivery.map((item, index) => (
                  <TableBody key={index}>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.title}
                        onChange={(e) => {
                          const updated = [...prasadHomeDelivery];
                          updated[index].title = e.target.value;
                          setPrasadHomeDelivery(updated);
                        }}
                        placeholder="Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.hindiTitle}
                        onChange={(e) => {
                          const updated = [...prasadHomeDelivery];
                          updated[index].hindiTitle = e.target.value;
                          setPrasadHomeDelivery(updated);
                        }}
                        placeholder="Hindi Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.price}
                        onChange={(e) => {
                          const updated = [...prasadHomeDelivery];
                          updated[index].price = e.target.value;
                          setPrasadHomeDelivery(updated);
                        }}
                        placeholder="Price"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.dollarPrice}
                        onChange={(e) => {
                          const updated = [...prasadHomeDelivery];
                          updated[index].dollarPrice = e.target.value;
                          setPrasadHomeDelivery(updated);
                        }}
                        placeholder="Dollar Price"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <button
                        onClick={() =>
                          addNewRow(setPrasadHomeDelivery, { title: "", hindiTitle: "", price: "", dollarPrice: "" })
                        }
                      >
                        <MdOutlineAddCard size={20} />
                      </button>
                      <button
                        onClick={() => deleteRow(index, setPrasadHomeDelivery)}
                      >
                        <MdDelete size={20} />
                      </button>
                    </TableCell>
                  </TableBody>
                ))}
              </Table>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group">
              <label>Puja Process</label>
              <Table>
                <TableHead>
                  <TableCell align="center">Step Number</TableCell>
                  <TableCell align="center">Title</TableCell>
                  <TableCell align="center">Hindi Title</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Hindi Description</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableHead>
                {pujaProcess.map((item, index) => (
                  <TableBody key={index}>
                    <TableCell align="center">
                      <input
                        type="number"
                        className="form-control"
                        value={item.stepNumber}
                        onChange={(e) => {
                          const updated = [...pujaProcess];
                          updated[index].stepNumber = parseInt(e.target.value);
                          setPujaProcess(updated);
                        }}
                        placeholder="Step Number"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.title}
                        onChange={(e) => {
                          const updated = [...pujaProcess];
                          updated[index].title = e.target.value;
                          setPujaProcess(updated);
                        }}
                        placeholder="Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item.hindiTitle}
                        onChange={(e) => {
                          const updated = [...pujaProcess];
                          updated[index].hindiTitle = e.target.value;
                          setPujaProcess(updated);
                        }}
                        placeholder="Hindi Title"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <textarea
                        className="form-control"
                        value={item.description}
                        onChange={(e) => {
                          const updated = [...pujaProcess];
                          updated[index].description = e.target.value;
                          setPujaProcess(updated);
                        }}
                        placeholder="Description"
                        rows={3}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <textarea
                        className="form-control"
                        value={item.hindiDescription}
                        onChange={(e) => {
                          const updated = [...pujaProcess];
                          updated[index].hindiDescription = e.target.value;
                          setPujaProcess(updated);
                        }}
                        placeholder="Hindi Description"
                        rows={3}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <button
                        onClick={() =>
                          addNewRow(setPujaProcess, { stepNumber: pujaProcess.length + 1, title: "", hindiTitle: "", description: "", hindiDescription: "" })
                        }
                      >
                        <MdOutlineAddCard size={20} />
                      </button>
                      <button onClick={() => deleteRow(index, setPujaProcess)}>
                        <MdDelete size={20} />
                      </button>
                    </TableCell>
                  </TableBody>
                ))}
              </Table>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group">
              <label>Live Darshan Links</label>
              <Table>
                <TableHead>
                  <TableCell align="center">Link</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableHead>
                {liveDarshanLinks.map((item, index) => (
                  <TableBody key={index}>
                    <TableCell align="center">
                      <input
                        type="text"
                        className="form-control"
                        value={item}
                        onChange={(e) =>
                          setLiveDarshanLinks((prev) => {
                            const updated = [...prev];
                            updated[index] = e.target.value;
                            return updated;
                          })
                        }
                        placeholder="Live Darshan Link"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <button
                        onClick={() => addNewRow(setLiveDarshanLinks, "")}
                      >
                        <MdOutlineAddCard size={20} />
                      </button>
                      <button
                        onClick={() => deleteRow(index, setLiveDarshanLinks)}
                      >
                        <MdDelete size={20} />
                      </button>
                    </TableCell>
                  </TableBody>
                ))}
              </Table>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Thumbnail Images</label>
              <input
                type="file"
                className="form-control"
                multiple
                onChange={(e) => handleImageChange(e, setThumbnail, setThumbnailUrls)}
              />
              <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {thumbnailUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Thumbnail ${index + 1}`}
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                ))}
              </div>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>Mandir Image</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) => handleSingleImageChange(e, setMadirImage, setMadirImageUrl)}
              />
              {madirImageUrl && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={madirImageUrl}
                    alt="Madir Image"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                </div>
              )}
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="form-group">
              <label>card Image</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) => handleSingleImageChange(e, setCardImage, setCardImageUrl)}
              />
              {cardImageUrl && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={cardImageUrl}
                    alt="card Image"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                </div>
              )}
            </div>
          </Grid>
          {/* <Grid item xs={6}>
            <div className="form-group">
              <label>Benefits Icons</label>
              <input
                type="file"
                className="form-control"
                multiple
                onChange={(e) => handleImageChange(e, setBenefitsIcons, setBenefitsIconsUrls)}
              />
              <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {benefitsIconsUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Benefit Icon ${index + 1}`}
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                ))}
              </div>
            </div>
          </Grid> */}
        </Grid>
        <div
          className="form-login-btn"
          onClick={handleSubmit}
          style={{ marginTop: "20px" }}
        >
          <Custombutton>
            { isLoading ? <BiLoader/> : pagetype === "Add" ?  "Submit" : "Update"}
          </Custombutton>
        </div>
      </Card>
    </div>
  );
};

export default AddNewPuja;